<style scoped>


</style>

<template>

<div>

    events map

</div>

</template>

<script>

export default{
    data:function(){
        return {

        }
    }
}

</script>


// WEBPACK FOOTER //
// src/assets/Dynamic/app/eventsmap/main.vue